module.exports = __webpack_public_path__ + "static/media/bdm-icons.7bb50805.svg";